import { render, staticRenderFns } from "./deleteBuildingForm.vue?vue&type=template&id=12d9fec1&scoped=true"
import script from "./deleteBuildingForm.vue?vue&type=script&lang=js"
export * from "./deleteBuildingForm.vue?vue&type=script&lang=js"
import style0 from "./deleteBuildingForm.vue?vue&type=style&index=0&id=12d9fec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d9fec1",
  null
  
)

export default component.exports